module.exports = __webpack_public_path__ + "img/12.03cde6cd.jpg";